// @ts-nocheck 5b2210bf
function add(editorAPI, appData, token, options) {
  return new Promise(function (resolve) {
    editorAPI.dsActions.waitForChangesApplied(function () {
      editorAPI.history.add(
        options.label,
        options.params !== undefined ? { __appParams: options.params } : null,
        options.historySnapshotId,
      );
      resolve();
    });
  });
}

function performUndoUntilLabel(editorAPI, appData, token, options) {
  return editorAPI.history.performUndoUntilLabel(
    options.snapshotLabel,
    options.shouldUndoSnapshotLabel,
  );
}

export { add, performUndoUntilLabel };
